<template>
    <CardTitle style="margin: 20px 0;">
        <template #cardTitle>
            Is this a referral from an HMI-accredited provider?
        </template>
        <template #cardSubtitle>
            <p style="font-style: italic; margin-top: 10px;">
                (Select this if another HMI-accredited doctor or provider referred you for this consultation.)
            </p>
            <v-checkbox
                v-model="isReq"
                label="Yes, this appointment is a referral."
                @change="handleChangeIsReq($event)"
            />
        </template>
    </CardTitle>
</template>

<script>
import CardTitle from './Other/CardTitle.vue'

export default {
    components: {
        CardTitle
    },
    props: ['isRequesting'],
    data: ()=>({
        isReq: false
    }),
    watch: {
        isRequesting(newVal) {
            this.isReq = newVal
        }
    },
    methods: {
        handleChangeIsReq(value) {
            this.$emit('changeIsReq', value)
        }
    }
}
</script>
